/**
 * Icon
 * @module components/Icon
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './Icon.scss';

/** Class representing the component. */
class Icon extends Component {

	/**
	 * The render method
	 */
	render () {
		const { icon, color } = this.props;
		const classes = color ? `${style.icon} ${style[icon]} ${style[color]}` : `${style.icon} ${style[icon]}`;

		return <span className={classes} />;
	}
}


/** Prop types **/
Icon.propTypes = {
	icon: PropTypes.string.isRequired,
	color: PropTypes.oneOf(['blue', 'red', 'turquoise', 'grey', 'grey-light', 'grey-dark', 'white'])
};


export default Icon;
